import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "./Header"
import Category from './components/Category'
import Footer from './components/Footer'
import { fetchCategoryDropdown } from "../../slice/category/categorySlice";
import { addToCart, fetchCart } from "../../slice/cart/cartSlice";
import { fetchUserProducts } from '../../slice/product/productSlice';
import { toast } from "react-toastify";
import Popuplogin from "./components/Popuplogin"
import Banner from "../users/components/banner/Banner"
import { useNavigate } from 'react-router-dom';

import {
  toggleFavourite,
  fetchFavourites
} from "../../slice/favourite/favouriteSlice";
import PopularCategory from "../users/components/PopularCategory"

const Home = () => {
  const dispatch = useDispatch();

  localStorage.getItem("userId");
  localStorage.getItem("token");

  const { dropdownCategories = [], loading: categoryLoading } = useSelector(
    (state) => state.category
  );

  const { userProducts = [], loading: productsLoading } = useSelector(
    (state) => state.product
  );

  const { user, token } = useSelector((state) => state.auth);
  const { loading: cartLoading } = useSelector((state) => state.cart);
  const navigate = useNavigate();

  // State for customizer modal
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedColor, setSelectedColor] = useState('');
  const [selectedProductColor, setSelectedProductColor] = useState('');
  const [selectedSize, setSelectedSize] = useState('');
  const [textInputs, setTextInputs] = useState([]);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [images, setImages] = useState([]);
  const [imageFiles, setImageFiles] = useState([]);
  const [mainSize, setMainSize] = useState('');
  const [validationErrors, setValidationErrors] = useState([]);
  const [showLoginModal, setShowLoginModal] = useState(false);

  // State for view modal
  const [viewImages, setViewImages] = useState([]);
  const [selectedViewImage, setSelectedViewImage] = useState(0);
  const [activeOrientation, setActiveOrientation] = useState('landscape');

  const defaultImage = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="400" height="500"%3E%3Crect fill="%23f0f0f0" width="400" height="500"/%3E%3Ctext x="50%25" y="50%25" font-size="20" fill="%23999" text-anchor="middle" dy=".3em"%3EYour Photo%3C/text%3E%3C/svg%3E';

  useEffect(() => {
    const loadData = async () => {
      try {
        await dispatch(fetchCategoryDropdown());
        await dispatch(fetchUserProducts({ page: 1, limit: 10 })).unwrap();
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    loadData();
  }, [dispatch]);

  // Filter only popular products and limit to 8
  const popularProducts = userProducts
    .filter(product => product.bestSellingProduct === true)
    .slice(0, 8);

  // ─── Extract all images from colorVariants (including preview images) ──────
  const extractProductImages = (product) => {
    if (!product) return [];
    
    const allImages = [];

    // Add preview image first if exists (as landscape)
    if (product.previewImage) {
      allImages.push({
        id: `preview_0`,
        url: `${process.env.REACT_APP_API_URL}/uploads/${product.previewImage.replace(/\\/g, '/')}`,
        thumb: `${process.env.REACT_APP_API_URL}/uploads/${product.previewImage.replace(/\\/g, '/')}`,
        orientation: 'landscape',
        isPreview: true
      });
    }

    // Add images from product.images array
    if (product.images && product.images.length > 0) {
      product.images.forEach((img, imgIndex) => {
        // Check if this image is not already added as preview
        if (img !== product.previewImage) {
          allImages.push({
            id: `product_${imgIndex}`,
            url: `${process.env.REACT_APP_API_URL}/uploads/${img.replace(/\\/g, '/')}`,
            thumb: `${process.env.REACT_APP_API_URL}/uploads/${img.replace(/\\/g, '/')}`,
            orientation: 'landscape',
            isPreview: false
          });
        }
      });
    }

    // Extract from colorVariants
    if (product.colorVariants && product.colorVariants.length > 0) {
      product.colorVariants.forEach((variant, variantIndex) => {
        // Landscape images
        if (variant.landscape?.images?.length) {
          variant.landscape.images.forEach((img, imgIndex) => {
            // Check if image already exists
            const imageUrl = `${process.env.REACT_APP_API_URL}/uploads/${img.replace(/\\/g, '/')}`;
            const exists = allImages.some(imgData => imgData.url === imageUrl);
            if (!exists) {
              allImages.push({
                id: `${variantIndex}_landscape_${imgIndex}`,
                url: imageUrl,
                thumb: imageUrl,
                orientation: 'landscape',
                variantIndex: variantIndex
              });
            }
          });
        }

        // Portrait images
        if (variant.portrait?.images?.length) {
          variant.portrait.images.forEach((img, imgIndex) => {
            const imageUrl = `${process.env.REACT_APP_API_URL}/uploads/${img.replace(/\\/g, '/')}`;
            const exists = allImages.some(imgData => imgData.url === imageUrl);
            if (!exists) {
              allImages.push({
                id: `${variantIndex}_portrait_${imgIndex}`,
                url: imageUrl,
                thumb: imageUrl,
                orientation: 'portrait',
                variantIndex: variantIndex
              });
            }
          });
        }

        // Add preview image from landscape if available
        if (variant.landscape?.previewImage) {
          const previewUrl = `${process.env.REACT_APP_API_URL}/uploads/${variant.landscape.previewImage.replace(/\\/g, '/')}`;
          const exists = allImages.some(imgData => imgData.url === previewUrl);
          if (!exists) {
            allImages.push({
              id: `${variantIndex}_landscape_preview`,
              url: previewUrl,
              thumb: previewUrl,
              orientation: 'landscape',
              variantIndex: variantIndex,
              isPreview: true
            });
          }
        }
      });
    }

    // Remove duplicates by URL
    const uniqueImages = [];
    const seenUrls = new Set();
    for (const img of allImages) {
      if (!seenUrls.has(img.url)) {
        seenUrls.add(img.url);
        uniqueImages.push(img);
      }
    }

    return uniqueImages;
  };

  // ─── Derived view modal values ───────────────────────────────────────────────
  const filteredViewImages = viewImages.filter(img => img.orientation === activeOrientation);
  const hasLandscapeImages = viewImages.some(img => img.orientation === 'landscape');
  const hasPortraitImages = viewImages.some(img => img.orientation === 'portrait');

  const getImagesByOrientation = (imgs, orientation) =>
    imgs.filter(img => img.orientation === orientation);

  // ─── Handlers ────────────────────────────────────────────────────────────────
  const handleOpenCustomizer = (product) => {
    setSelectedProduct(product);
    setValidationErrors([]);

    if (product.sizes && product.sizes.length > 0) {
      setMainSize(product.sizes[0].name);
      setSelectedSize(product.sizes[0].name);
    }

    if (product.colors && product.colors.length > 0) {
      setSelectedProductColor(product.colors[0].code);
    }

    const textCount = product.textCount || 0;
    setTextInputs(Array(textCount).fill(''));

    const imageCount = product.imageCount || 0;
    setImages(Array(imageCount).fill(''));
    setImageFiles([]);

    setSelectedColor('');
    setCurrentImageIndex(0);
  };

  // ─── Updated: includes preview images ────────────────────────────────────────
  const handleOpenViewModal = (product) => {
    if (!product) return;

    const allImages = extractProductImages(product);
    setViewImages(allImages);
    setSelectedViewImage(0);
    setActiveOrientation('landscape');
  };

  const handleNextImage = () => {
    if (filteredViewImages.length > 0) {
      setSelectedViewImage((prev) => (prev + 1) % filteredViewImages.length);
    }
  };

  const handlePrevImage = () => {
    if (filteredViewImages.length > 0) {
      setSelectedViewImage((prev) => (prev - 1 + filteredViewImages.length) % filteredViewImages.length);
    }
  };

  const handleColorChange = (color) => {
    setSelectedColor(color);
    setValidationErrors([]);
  };

  const handleTextChange = (index, value) => {
    const newTexts = [...textInputs];
    newTexts[index] = value;
    setTextInputs(newTexts);
    setValidationErrors([]);
  };

  const handleImageUpload = (index, event) => {
    const file = event.target.files[0];
    if (!file) return;

    const newFiles = [...imageFiles];
    newFiles[index] = file;
    setImageFiles(newFiles);

    const reader = new FileReader();
    reader.onload = (e) => {
      const newImages = [...images];
      newImages[index] = e.target.result;
      setImages(newImages);
    };
    reader.readAsDataURL(file);

    setValidationErrors([]);
  };

  const validateForm = () => {
    const errors = [];

    if (!selectedProduct) {
      errors.push("No product selected");
      setValidationErrors(errors);
      return false;
    }

    if (selectedProduct.imageCount > 0) {
      const uploadedImages = images.filter(img => img !== '');
      if (uploadedImages.length < selectedProduct.imageCount) {
        errors.push(`Please upload ${selectedProduct.imageCount} image(s)`);
      }
    }

    if (selectedProduct.textCount > 0) {
      const emptyTexts = textInputs.some(text => !text.trim());
      if (emptyTexts) {
        errors.push("Please fill in all text fields");
      }
    }

    if (!mainSize) {
      errors.push("Please select a frame size");
    }

    if (!selectedColor || selectedColor.trim() === "") {
      errors.push("Please select a frame color");
    }

    setValidationErrors(errors);
    return errors.length === 0;
  };

  const resetCustomizer = () => {
    setSelectedProduct(null);
    setSelectedColor("");
    setSelectedProductColor("");
    setSelectedSize("");
    setTextInputs([]);
    setImages([]);
    setImageFiles([]);
    setCurrentImageIndex(0);
    setMainSize("");
    setValidationErrors([]);
  };

  const handleAddToCart = () => {
    if (!user || !token) {
      console.warn('Authentication required - User:', user, 'Token:', !!token);
      setShowLoginModal(true);
      return;
    }

    if (!validateForm()) {
      console.warn('Form validation failed');
      return;
    }

    const formData = new FormData();

    formData.append("productId", selectedProduct._id);
    formData.append("frameSize", mainSize);
    formData.append("frameColor", selectedColor);
    formData.append("productColor", selectedProductColor || "");
    formData.append("quantity", 1);

    textInputs.forEach((text) => {
      formData.append("texts[]", text);
    });

    imageFiles.forEach((file) => {
      if (file) {
        formData.append("images", file);
      }
    });

    dispatch(addToCart(formData))
      .unwrap()
      .then(() => {
        dispatch(fetchCart());
        toast.success("Item added to cart 🛒");
        const modalEl = document.getElementById("exampleModal");
        if (modalEl) {
          const modalInstance =
            window.bootstrap?.Modal.getInstance(modalEl) ||
            new window.bootstrap.Modal(modalEl);
          modalInstance.hide();
        }
        resetCustomizer();
      })
      .catch((error) => {
        console.error('Add to cart error:', error);
        if (error === "Please login to add items to cart") {
          setShowLoginModal(true);
          toast.error("Please login first");
        } else {
          toast.error(error || "Failed to add item");
        }
      });
  };

  const { items: favourites, loading: favLoading } = useSelector(
    (state) => state.favourite
  );

  const isFavourite = (productId) => {
    return favourites.some(
      (fav) => String(fav.product?._id) === String(productId)
    );
  };

  const handleFavouriteClick = async (productId) => {
    if (!user || !token) {
      setShowLoginModal(true);
      return;
    }

    const alreadyFav = isFavourite(productId);

    try {
      await dispatch(toggleFavourite(productId)).unwrap();
      if (alreadyFav) {
        toast.info("Removed from wishlist 💔");
      } else {
        toast.success("Added to wishlist ❤️");
      }
    } catch (error) {
      toast.error(error || "Something went wrong");
    }
  };

  const popularCategories = dropdownCategories.filter(
    (cat) => cat.isPopular === true
  );

  useEffect(() => {
    if (token) {
      dispatch(fetchFavourites());
    }
  }, [dispatch, token]);

  const handleShare = async (product) => {
    const shareData = {
      title: product.name,
      text: `Check out ${product.name} - ₹${product.sellingPrice}`,
      url: `${window.location.origin}/product/${product._id}`,
    };

    try {
      if (navigator.share) {
        await navigator.share(shareData);
      } else {
        await navigator.clipboard.writeText(shareData.url);
        toast.success("Link copied to clipboard! 🔗");
      }
    } catch (err) {
      if (err.name !== "AbortError") {
        toast.error("Failed to share");
      }
    }
  };

  // Get product display image
  const getProductImage = (product) => {
    if (product.previewImage) {
      return `${process.env.REACT_APP_API_URL}/uploads/${product.previewImage}`;
    }
    if (product.images && product.images.length > 0) {
      return `${process.env.REACT_APP_API_URL}/uploads/${product.images[0]}`;
    }
    // Check colorVariants for first image
    if (product.colorVariants && product.colorVariants.length > 0) {
      const firstVariant = product.colorVariants[0];
      if (firstVariant.landscape?.images?.length) {
        return `${process.env.REACT_APP_API_URL}/uploads/${firstVariant.landscape.images[0]}`;
      }
      if (firstVariant.portrait?.images?.length) {
        return `${process.env.REACT_APP_API_URL}/uploads/${firstVariant.portrait.images[0]}`;
      }
    }
    return defaultImage;
  };

  return (
    <div className="page-wraper">
      <Header
        dropdownCategories={dropdownCategories}
        loading={categoryLoading}
        setShowLoginModal={setShowLoginModal}
      />

      <div className="page-content bg-light">
        {/* Banner */}
        <div className="container SpacE">
          <Banner />
        </div>

        <div id="category-section">
          <Category dropdownCategories={dropdownCategories} loading={categoryLoading} />
        </div>

        <PopularCategory
          dropdownCategories={popularCategories}
          loading={categoryLoading}
        />

        {/* Best Selling Products Section */}
        <section className="content-innerNO overflow-hidden">
          <div className="container">
            <div className="section-head text-left">
              <h2 className="title">Best Selling Products</h2>
            </div>

            {productsLoading ? (
              <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              <div className="row gx-xl-4 g-3">
                {popularProducts.length > 0 ? (
                  popularProducts.map((product) => (
                    <div key={product._id} className="col-lg-4 col-xl-3 col-md-6 col-sm-12 relative mobilecard">
                      <div className="">
                        {product?.label?.name && (
                          <div className="DR_productLabel">
                            {product.label.name}
                          </div>
                        )}
                        <div className="SP_card">
                          <div className="SP_image_wrapper">
                            <img
                              src={getProductImage(product)}
                              className="SP_frame_image"
                              alt={product.name}
                              onError={(e) => {
                                e.target.src = defaultImage;
                              }}
                            />

                            <div
                              className={`btn-primary meta-icon dz-wishicon ${isFavourite(product._id) ? "active" : ""
                                } ${favLoading ? "disabled" : ""}`}
                              onClick={() => handleFavouriteClick(product._id)}
                            >
                              <i className="fa-solid fa-heart fill"></i>
                              <i className="fa-regular fa-heart unfill"></i>
                            </div>

                            <div
                              className="btn btn-primary meta-icon dz-carticon"
                              onClick={() => handleShare(product)}
                            >
                              <i className="fa-solid fa-share-nodes"></i>
                            </div>

                            <div
                              className="btn btn-primary meta-icon dz-view"
                              data-bs-toggle="modal"
                              data-bs-target="#quick-view"
                              onClick={() => handleOpenViewModal(product)}
                            >
                              <i className="fa-solid fa-eye"></i>
                            </div>

                            <a className="share-btn" href="#"></a>
                          </div>

                          <div className="rowMAIN">
                            <h3 className="SP_title">{product.name}</h3>
                            <div className="SP_price_row">
                              <span className="SP_current_price">₹{product.sellingPrice}</span>
                              <span className="SP_original_price">₹{product.mrp}</span>
                            </div>
                            <button
                              className="SP_customize_button"
                              onClick={() => navigate(`/customize/${product._id}`)}
                            >
                              Upload &amp; Customize
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="col-12 text-center py-5">
                    <div className="nodata">No popular products available</div>
                  </div>
                )}
              </div>
            )}
          </div>
        </section>
      </div>

      <Footer />

      {/* ── Quick View Modal with Tabbed Gallery ─────────────────────────────────── */}
      <div className="modal quick-view-modal fade" id="quick-view" tabIndex={-1} aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-xl">
          <div className="modal-content" style={{ borderRadius: '16px', overflow: 'hidden', border: 'none' }}>

            {/* Close Button */}
            <button
              type="button"
              data-bs-dismiss="modal"
              aria-label="Close"
              style={{
                position: 'absolute', top: '14px', right: '14px',
                width: '34px', height: '34px', borderRadius: '50%',
                border: '1px solid #e5e7eb', background: '#fff',
                cursor: 'pointer', zIndex: 10, display: 'flex',
                alignItems: 'center', justifyContent: 'center',
                fontSize: '18px', color: '#6b7280', lineHeight: 1
              }}
            >
              &#x2715;
            </button>

            <div className="modal-body p-0" style={{ minHeight: '520px' }}>

              {/* Gallery */}
              <div style={{
                padding: '24px',
                display: 'flex',
                flexDirection: 'column',
                gap: '14px',
                background: '#fafafa'
              }}>

                {/* Orientation Tabs */}
                {(hasLandscapeImages || hasPortraitImages) && (
                  <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                    {hasLandscapeImages && (
                      <button
                        onClick={() => { setActiveOrientation('landscape'); setSelectedViewImage(0); }}
                        style={{
                          padding: '6px 16px', borderRadius: '8px',
                          background: activeOrientation === 'landscape' ? '#f97316' : '#fff',
                          color: activeOrientation === 'landscape' ? '#fff' : '#6b7280',
                          border: activeOrientation === 'landscape' ? 'none' : '1px solid #e5e7eb',
                          cursor: 'pointer', fontWeight: 600, fontSize: '13px', transition: 'all 0.2s'
                        }}
                      >
                        🖼️ Landscape ({getImagesByOrientation(viewImages, 'landscape').length})
                      </button>
                    )}
                    {hasPortraitImages && (
                      <button
                        onClick={() => { setActiveOrientation('portrait'); setSelectedViewImage(0); }}
                        style={{
                          padding: '6px 16px', borderRadius: '8px',
                          background: activeOrientation === 'portrait' ? '#f97316' : '#fff',
                          color: activeOrientation === 'portrait' ? '#fff' : '#6b7280',
                          border: activeOrientation === 'portrait' ? 'none' : '1px solid #e5e7eb',
                          cursor: 'pointer', fontWeight: 600, fontSize: '13px', transition: 'all 0.2s'
                        }}
                      >
                        📱 Portrait ({getImagesByOrientation(viewImages, 'portrait').length})
                      </button>
                    )}
                  </div>
                )}

                {/* Main Image + Arrows */}
                <div style={{
                  flex: 1, position: 'relative', background: '#fff',
                  borderRadius: '12px', border: '1px solid #f0f0f0',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  minHeight: '400px', overflow: 'hidden'
                }}>
                  {filteredViewImages.length > 1 && (
                    <>
                      <button onClick={handlePrevImage} style={{
                        position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)',
                        width: '36px', height: '36px', borderRadius: '50%',
                        background: 'rgba(0,0,0,0.5)', color: '#fff', border: 'none',
                        cursor: 'pointer', fontSize: '20px', zIndex: 5,
                        display: 'flex', alignItems: 'center', justifyContent: 'center'
                      }}>‹</button>
                      <button onClick={handleNextImage} style={{
                        position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)',
                        width: '36px', height: '36px', borderRadius: '50%',
                        background: 'rgba(0,0,0,0.5)', color: '#fff', border: 'none',
                        cursor: 'pointer', fontSize: '20px', zIndex: 5,
                        display: 'flex', alignItems: 'center', justifyContent: 'center'
                      }}>›</button>
                    </>
                  )}

                  {filteredViewImages.length > 0 ? (
                    <img
                      src={filteredViewImages[selectedViewImage]?.url}
                      alt="Product"
                      style={{ maxWidth: '100%', maxHeight: '450px', objectFit: 'contain', borderRadius: '8px' }}
                    />
                  ) : (
                    <div style={{ textAlign: 'center', color: '#9ca3af' }}>
                      <div style={{ fontSize: '40px', marginBottom: '8px' }}>🖼️</div>
                      <p style={{ fontSize: '14px' }}>No images available</p>
                    </div>
                  )}
                </div>

                {/* Thumbnail Strip */}
                {filteredViewImages.length > 1 && (
                  <div style={{ display: 'flex', gap: '8px', overflowX: 'auto', paddingBottom: '4px' }}>
                    {filteredViewImages.map((image, index) => (
                      <button
                        key={image.id}
                        onClick={() => setSelectedViewImage(index)}
                        style={{
                          width: '60px', height: '60px', flexShrink: 0,
                          border: selectedViewImage === index ? '2px solid #f97316' : '1.5px solid #e5e7eb',
                          borderRadius: '8px', overflow: 'hidden',
                          cursor: 'pointer', padding: 0, background: '#fff',
                          transition: 'border-color 0.2s'
                        }}
                      >
                        <img
                          src={image.thumb}
                          alt={`Thumb ${index + 1}`}
                          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                      </button>
                    ))}
                  </div>
                )}

                {/* Counter */}
                {filteredViewImages.length > 0 && (
                  <div style={{ fontSize: '12px', color: '#9ca3af', textAlign: 'center' }}>
                    {selectedViewImage + 1} / {filteredViewImages.length} images
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Login Modal */}
      {showLoginModal && (
        <div className="modal fade show" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content POP">
              <Popuplogin onClose={() => setShowLoginModal(false)} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;